/**
 * @fileoverview POST handler for the "/engagement/canvas/llm_step_preview" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasLlmStepPreviewCacheKeys } from "./constants";
import type { PostEngagementCanvasLlmStepPreviewProps, EngagementCanvasLlmStepPreviewResult } from "./types";

export const postEngagementCanvasLlmStepPreview = reactQueryMutationAdapter(
  engagementCanvasLlmStepPreviewCacheKeys,
  (props: PostEngagementCanvasLlmStepPreviewProps): Promise<EngagementCanvasLlmStepPreviewResult> => {
    return fetch("/engagement/canvas/llm_step_preview", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    }).then((res: EngagementCanvasLlmStepPreviewResult) => {
      // A failed execution that applied the agent's fallback resolves, so the preview can show the fallback.
      if (res.errors && res.errors.length > 0 && !res.fallback_result) {
        // Throw a structured error so downstream handlers can extract the error code.
        // The first error from the backend is used as the message.
        throw new Error(res.errors[0]);
      }

      return res;
    });
  }
);
